import Reviews from '@/services/Api/Awards/Reviews';
import { handleAuthorization, handleFormValidations } from '@ifac/ui';

export default {
  methods: {
    mx_update() {
      this.formErrors = {};
      Reviews
        .update(this.mx_reviewId, {
          form_values: this.formValues,
        })
        .then(() => {
          this.$snack.success({
            text: 'Review saved',
          });
        })
        .catch((error) => {
          this.handleError(error);
        });
    },
    mx_submit() {
      this.formErrors = {};
      return Reviews
        .submit(this.mx_reviewId, {
          form_values: this.formValues,
        })
        .then(() => {
          this.$snack.success({
            text: 'Review submitted',
          });
          this.$router.push({ name: 'Reviews' });
        })
        .catch((error) => {
          this.handleError(error);
        });
    },
    handleError(error) {
      handleAuthorization(error).then((msg) => {
        if (msg) {
          this.$snack.success({ text: msg });
        }
      });

      handleFormValidations(error).then((errors) => {
        if (errors) {
          this.$snack.success({ text: 'You have some validation errors, try again please.' });
          this.formErrors = errors;
        }
      });
    },
  },
  computed: {
    mx_reviewId() {
      return this.$route.params.review;
    },
  },
};
